module.exports = __webpack_public_path__ + "img/pricingTypesIllustrations.264f6bd7.svg";